

































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PathViewModel, Path } from '@/features/bots/models/designer';
import { Getter, Mutation } from 'vuex-class';
import shortid from 'shortid';
import { ADD_PATH, SET_CURRENT_PATH } from '@/store/bot-designer/paths/mutationTypes';
import { mixin as clickaway } from 'vue-clickaway';
import {dropDownHelper} from '@/shared/components/dropDownMenu/dropDownHelper';

@Component({
	mixins: [
		clickaway
	]
})
export default class PathPicker extends Vue {
	@Getter public paths!: PathViewModel[];
	@Getter public currentPath!: Path;
	@Prop() public value: string;
	@Prop({default : false}) public fixed: boolean;
	@Mutation(ADD_PATH) public addPath: (path: PathViewModel) => void;
	@Mutation(SET_CURRENT_PATH) public setCurrentPath: (id: string) => void;

	public selected: string;
	public isOpen = false;

	public isUp = false;


	@Watch('value', { immediate: true })
	public onValueChanged(value: string, previous: string) {
		this.selected = value;
	}

	public getPathsToChooseFrom() {
		return this.paths.filter(p => p.id !== this.currentPath.id);
	}

	public getDescription() {
		if (!this.selected) {
			return 'Choose a path...';
		}
		const selectedPath = this.paths.find(p => p.id === this.selected);
		if (!selectedPath) {
			this.selected = '';
			this.$emit('path-selected', this.selected);
			return 'Choose a path...';
		}

		return selectedPath.name;
	}

	public choosePath(pathId: string) {
		this.selected = pathId;
		this.$emit('path-selected', this.selected);
	}

	public addNewPath() {
		const newPath = {
			id: `path-${shortid.generate()}`,
			name: `New Path`,
			states: [],
		} as PathViewModel;

		this.addPath(newPath);

		this.selected = newPath.id;
		this.$emit('path-selected', this.selected);
	}

	public closePicker() {
		this.isOpen = false;
		this.isUp = false;
	}

	public togglePicker() {
		// don't allow opening the menu/choosing a path if the picker should be 'fixed'
		if (this.fixed) {
			return;
		}

		this.isOpen = !this.isOpen;

		this.$nextTick(() => this.isUp = dropDownHelper.isDropDownUp());
	}

	public hasSelectedPath(pathId: string) {
		return pathId && pathId.length > 0;
	}

	public goToPath(pathId: string) {
		this.setCurrentPath(pathId);
	}
}
